(function () {
    const STORAGE_KEY = 'bayse-wishlist-count';
    const callbacks = [
      ['SWCallbackExpressWishlistProductItemAdded', 1],
      ['SWCallbackExpressWishlistCollectionItemAdded', 1],
      ['SWCallbackCustomerWishlistProductItemAdded', 1],
      ['SWCallbackCustomerWishlistCollectionItemAdded', 1],
      ['SWCallbackExpressWishlistProductItemRemoved', -1],
      ['SWCallbackExpressWishlistCollectionItemRemoved', -1],
      ['SWCallbackCustomerWishlistProductItemRemoved', -1],
      ['SWCallbackCustomerWishlistCollectionItemRemoved', -1],
    ];
  
    let lastDelta = 0;
    let lastDeltaAt = 0;
  
    function readCount() {
      try {
        const value = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
        return Number.isFinite(value) && value > 0 ? value : 0;
      } catch (error) {
        return 0;
      }
    }
  
    function writeCount(count) {
      try {
        localStorage.setItem(STORAGE_KEY, String(Math.max(0, Number(count) || 0)));
      } catch (error) {}
    }
  
    function applyDot(count) {
      const dots = document.querySelectorAll('[data-wishlist-dot]');
      const hidden = !(count > 0);
      for (const dot of dots) {
        dot.hidden = hidden;
      }
    }
  
    function setCount(count) {
      writeCount(count);
      applyDot(count);
    }
  
    function onDelta(delta) {
      const now = Date.now();
      if (delta === lastDelta && now - lastDeltaAt < 300) return;
      lastDelta = delta;
      lastDeltaAt = now;
      const current = readCount();
      setCount(delta > 0 ? current + 1 : Math.max(0, current - 1));
    }
  
    function wrapCallbacks() {
      for (const [name, delta] of callbacks) {
        const previous = window[name];
        if (previous && previous.__bayseWishlistDot) continue;
        const wrapped = function () {
          if (typeof previous === 'function') previous.apply(this, arguments);
          onDelta(delta);
        };
        wrapped.__bayseWishlistDot = true;
        window[name] = wrapped;
      }
    }
  
    document.addEventListener('wishlist:update', function (event) {
      const count =
        event.detail && typeof event.detail.count === 'number' ? event.detail.count : readCount();
      setCount(count);
    });
  
    window.addEventListener('storage', function (event) {
      if (event.key === STORAGE_KEY) applyDot(readCount());
    });
  
    const previousLoaded = window.SWCallbackWishlistButtonLoaded;
    window.SWCallbackWishlistButtonLoaded = function () {
      if (typeof previousLoaded === 'function') previousLoaded.apply(this, arguments);
      wrapCallbacks();
    };
  
    wrapCallbacks();
    applyDot(readCount());
  })();
  